<template>
  <TabbedBox>
    <template v-slot:tablist>
      <Tab :first="true" tabid="tab-1">
        <i class="far fa-exchange"></i> Stock Transactions
      </Tab>
    </template>
    <template v-slot:tabcontent>
      <TabPage :first="true" tabid="tab-1">
        <StockTransactionDataTable ref="stockTransactionsDataTable">
          <template v-slot:title>
            <h3>Stock Transactions</h3>
          </template>
          <template v-slot:tools>
            <ActionButton type="new" v-if="userHasCreatePermission(PermissionTypes.InventoryPermissionTypes.stockTransaction)" @click="addAdjustment"> Add Adjustment</ActionButton>
          </template>
        </StockTransactionDataTable>

      </TabPage>
    </template>
  </TabbedBox>
</template>

<script>
import StockTransactionDataTable from '@/modules/inventory/components/stockTransactionDataTable'
import StockTransactionDialog from '@/modules/inventory/views/stockTransactionDialog.vue'

export default {
  name: 'StockTransaction',
  components: {
    StockTransactionDataTable
  },
  mounted() {
  },
  methods: {    
    addAdjustment() {
      this.displayModal(StockTransactionDialog)
      .then((success) => {
        if(success) {
          this.successToast('Adjustment Created')
          this.$refs.stockTransactionsDataTable.reload()
        }
      })
    },
  },
}
</script>
